<app-loader [label]="data.label" [loaderType]="data.loaderType"></app-loader>
<span *ngIf="data.status" class="progress-number">{{data.status | number: '1.0-2'}} %</span>
